import Icon from '@components/atoms/Icon'
import React from 'react'
import Image from '../../utils/components/atoms/Image'

interface AccordionBlock {
  heading: string
  description: string
  image?:string
}

interface VariantAccordionProps {
  componentClasses: string
  variantAccordionBlocks?: AccordionBlock[]
  accordionBlocks?: AccordionBlock[]
  witbBlocks?: AccordionBlock[]
}

const ProductDrawers: React.FC<VariantAccordionProps> = ({
  componentClasses,
  variantAccordionBlocks,
  accordionBlocks,
  witbBlocks
}) => {
  return (
    <div className="pv-pdp-drawers pt-6">
      <div className="border-t border-solid border-black">
        {variantAccordionBlocks?.slice(0, 1).map((block, index) => {
          const { heading, description } = block

          if (!heading || !description) return null
          const defaultOpen = heading.includes("Tech Specs") || heading.includes("Details");
          return (
            <div key={index} className={`block ${componentClasses}`}>
              <details className="group/accordion py-4 lg:py-5 transition-max-height duration-500 ease-out overflow-hidden group-open/accordion:max-h-96" open={defaultOpen}>
                <summary className="[&::-webkit-details-marker]:hidden flex cursor-pointer flex-row items-center justify-between font-semibold text-black body-md">
                  <span className="text-black body-md" dangerouslySetInnerHTML={{ __html: heading }}></span>
                  <Icon
                    name="icon-arrow-down"
                    className="transition-transform duration-500 stroke-black group-open/accordion:rotate-180"
                  />
                </summary>
                <div className="group-open/accordion:max-h-96">
                  <p className="text-black body-md pt-5" dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              </details>
            </div>
          )
        })}
        {accordionBlocks?.map((block, index) => {
          const { heading, description } = block

          if (!heading || !description) return null
          const defaultOpen = heading.includes("Tech Specs") || heading.includes("Details");
          return (
            <div key={index} className={`block ${componentClasses}`}>
              <details className="group/accordion py-4 lg:py-5 transition-max-height duration-500 ease-out overflow-hidden group-open/accordion:max-h-96" open={defaultOpen}>
                <summary className="[&::-webkit-details-marker]:hidden flex cursor-pointer flex-row items-center justify-between font-semibold text-black body-md">
                  <span className="text-black body-md" dangerouslySetInnerHTML={{ __html: heading }}></span>
                  <Icon
                    name="icon-arrow-down"
                    className="transition-transform duration-500 stroke-black group-open/accordion:rotate-180"
                  />
                </summary>
                <div className="group-open/accordion:max-h-96">
                  <p className="text-black body-md pt-5" dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              </details>
            </div>
          )
        })}
        {witbBlocks?.slice(0, 1).map((block, index) => {
          const { heading, description, image } = block

          if (!heading || !description) return null
          const defaultOpen = heading.includes("Tech Specs") || heading.includes("Details");
          return (
            <div key={index} className={`block ${componentClasses}`}>
              <details className="group/accordion py-4 lg:py-5 transition-max-height duration-1000 ease-out overflow-hidden" open={defaultOpen}>
                <summary className="[&::-webkit-details-marker]:hidden flex cursor-pointer flex-row items-center justify-between font-semibold text-black body-md">
                  <span className="text-black body-md" dangerouslySetInnerHTML={{ __html: heading }}></span>
                  <Icon
                    name="icon-arrow-down"
                    className="transition-transform duration-500 stroke-black group-open/accordion:rotate-180"
                  />
                </summary>
                <div className="group-open/accordion:max-h-96">
                  <p className="text-black body-md pt-5 pb-5" dangerouslySetInnerHTML={{ __html: description }} />
                </div>
                {image && (
                  <div className="max-w-xs lg:max-w-sm">
                    <Image src={image} alt="Tech specs Infographic"/>
                  </div>
                )}
              </details>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProductDrawers
